import type { BaseRecord, TableProps } from "./types"
import { TableScope } from "./TableScope"
import { Table } from "./Table"

export function Cable<R extends BaseRecord>(props: TableProps<R>) {
  return (
    <TableScope<R>>
      <Table {...props} />
    </TableScope>
  )
}
